export const NEW_BLACK_01 = '#1E1E1E';
export const NEW_GREY_01 = '#878787';
export const NEW_GREY_02 = '#484848';
export const MAXIMUM_DESKTOP_IMAGE_WIDTH = 880;
export const MAXIMUM_MOBILE_IMAGE_WIDTH = 340;
